import { getRequest } from 'global/helpers/requests'
import type { MapSourceGroup } from './types'

export const getMapSourceGroups = async (source: string): Promise<MapSourceGroup[]> =>
  await getRequest<MapSourceGroup[]>('carrier/rgs/groups', {}, 'carrier-management')
